import { ChangeEvent, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
  signInApplicant,
  confirmSignUpApplicant,
  userSelector,
  incrementalId,
  setLoadingState,
  trullyFirstStep
} from 'src/store/User/user.slice';
import addUserToGroup from 'src/functions/addUserToGroup';
import getIp from 'src/functions/getIp';
import { useGeolocation } from 'src/hooks/useGeolocation';
import getCurrentDate from 'src/functions/getCurrentDate';
import { ModalSignupSuccess } from './signupSuccess.styles';
import { RootState } from 'src/store/store';
import { useAppThunkDispatch } from 'src/store/store';
//import { resendConfirmationCode } from '../../../middlewares/Auth';

type ModalSignupSuccessProps = {
  userId: string;
  email: string;
  password: string;
  showSuccessModal: boolean;
};

const SignupSuccess: React.FC<ModalSignupSuccessProps> = ({ showSuccessModal, email }) => {
  const currentUser = useSelector(userSelector);
  const [disabled, setDisabled] = useState(true);
  const [verifierCode, setVerifierCode] = useState('');
  const dispatch = useAppThunkDispatch();
  const navigate = useNavigate();
  const { errorType } = useSelector((state: RootState) => state.user);
  const { getUserLocation, error: errorGeolocation } = useGeolocation();

  const handleCode = (e: ChangeEvent<HTMLInputElement>) => {
    const code = e.target.value;
    setVerifierCode(code);
    const isValidCode = code.length >= 6 && /^\d+$/.test(code);
    setDisabled(!isValidCode);
  };
  const handleClick = () => {
    verifyAuthCode();
  };
  const errorText = () => {
    switch (errorType) {
      case 'CodeMismatchException':
        return 'Código incorrecto, vuelve a ingresarlo';
      case 'User is already confirmed.':
        return (
          <>
            Ya has verificado tu correo anteriormente
            <Link to="/iniciar-sesion">Iniciar sesión.</Link>
          </>
        );
      case 'Confirmation code cannot be empty':
        return 'Ingresa de nuevo el código de confirmación';
    }
  };

  const verifyAuthCode = async () => {
    setDisabled(true);
    const userGeolocation = await getUserLocation().catch((err) => {
      console.error('Error getting geolocation:', err);
      return null;
    });
    if (!userGeolocation) {
      dispatch(setLoadingState(false));
      return alert('ERRORR');
    }
    const [ip, date] = await Promise.all([getIp(), getCurrentDate()]);
    dispatch(setLoadingState(false));

    const user = {
      id: currentUser.id,
      email: currentUser.email,
      password: currentUser.password,
      ip,
      geolocation: userGeolocation,
      date,
      code: verifierCode,
      showSuccessModal
    };
    const trully = {
      id: currentUser.id,
      typeOfUser: 'applicant'
    };
    try {
      await dispatch(confirmSignUpApplicant({ user }));
      await addUserToGroup(user.email, 'applicant');
      await dispatch(signInApplicant({ email: user.email, password: user.password }));
      const trullyResponse = await dispatch(trullyFirstStep(trully));
      if (trullyResponse.payload === 'No Threat') {
        await dispatch(incrementalId({ id: user.id, typeOfUser: 'applicant' }));
      } else {
        navigate('/validation-page');
        return;
      }
    } catch (error) {
      console.error('error confirming sign up', error);
      return;
    }
    navigate('/solicitante/onboarding-data');
  };

  return (
    <>
      {showSuccessModal && (
        <ModalSignupSuccess>
          <div>
            <h2>
              ¡Has creado tu cuenta en <span>FINSPHERA!</span>
            </h2>
            <p>¡Estás a punto de pertenecer a FinSphera!</p>
            <p>
              Enviamos un correo a <span>{email}</span> para confirmar tu cuenta; Ingresa el código.
            </p>
            <input name="code" type="text" onChange={handleCode} />
            <button onClick={handleClick} disabled={disabled}>
              Enviar
            </button>
            {errorType && <p>{errorText()}</p>}
          </div>
        </ModalSignupSuccess>
      )}
    </>
  );
};

export default SignupSuccess;
